import { render, staticRenderFns } from "./ContractDispatch.vue?vue&type=template&id=b47827e6&scoped=true&"
import script from "./ContractDispatch.vue?vue&type=script&lang=js&"
export * from "./ContractDispatch.vue?vue&type=script&lang=js&"
import style0 from "./ContractDispatch.vue?vue&type=style&index=0&id=b47827e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47827e6",
  null
  
)

export default component.exports